<template>
<div id="app">
  <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
  <!--
  <el-menu-item index="1"><router-link to="/Home">Home</router-link></el-menu-item>
  <el-menu-item index="2"><router-link to="/ClerkSubmit">Clerk Submit</router-link></el-menu-item>
  <el-menu-item index="3"><router-link to="/DoctorApproval">Doctor Approval</router-link></el-menu-item>
  <el-menu-item index="4"><router-link to="/FlowPage">Reviw</router-link></el-menu-item>
  <el-menu-item index="5"><router-link to="/PrescriptionPage">Prescription</router-link></el-menu-item>
  <el-menu-item index="6"><router-link to="/ReviewPage">Flow Pag</router-link></el-menu-item>
  <el-menu-item index="7"><router-link to="/RecipeAdd1">RecipeAdd1</router-link></el-menu-item>
  <el-menu-item index="8"><router-link to="/RecipeAdd2">RecipeAdd2</router-link></el-menu-item>
  <el-menu-item index="9"><router-link to="/RecipeAdd3">RecipeAdd3</router-link></el-menu-item>
  <el-menu-item index="10"><router-link to="/SignUpdate">SignUpdate</router-link></el-menu-item>
  <el-menu-item index="17"><router-link to="/RecipePrint">查看处方</router-link></el-menu-item>

  <el-menu-item index="12"><router-link to="/BatchPrint">BatchPrint</router-link></el-menu-item>
  <el-menu-item index="13"><router-link to="/GetYao">GetYao</router-link></el-menu-item>
  <el-menu-item index="14"><router-link to="/AddDrug">AddDrug</router-link></el-menu-item>
-->
  <el-menu-item index="16" style="color:black"><router-link to="/SignCheck">申请处方</router-link></el-menu-item>

  <el-menu-item index="11" style="color:black"><router-link to="/Audit">查看处方状态</router-link></el-menu-item>

  <el-menu-item index="15" style="color:black"><router-link to="/Success">审核完成</router-link></el-menu-item>  
  <el-menu-item index="17" style="color:black"><router-link to="/DrugAdd">添加药品</router-link></el-menu-item>

  <el-menu-item index="18" style="float:right"><router-link to="/Logout">退出登录</router-link></el-menu-item>

<!-- del this line after finish add drug page -->
<!-- <el-menu-item index="16"><router-link to="/AddDrug">添加药品</router-link></el-menu-item>

<el-menu-item index="17"><router-link to="/RecipeAdd1">添加药品</router-link></el-menu-item> -->

  <!-- <el-submenu index="7">
    <template slot="title">我的工作台</template>
    <el-menu-item index="7-1">选项1</el-menu-item>
    <el-menu-item index="7-2">选项2</el-menu-item>
    <el-menu-item index="7-3">选项3</el-menu-item>
    <el-submenu index="7-4">
      <template slot="title">选项4</template>
      <el-menu-item index="7-4-1">选项1</el-menu-item>
      <el-menu-item index="7-4-2">选项2</el-menu-item>
      <el-menu-item index="7-4-3">选项3</el-menu-item>
    </el-submenu>
  </el-submenu>
  <el-menu-item index="8" disabled>消息中心</el-menu-item>
  <el-menu-item index="9"><a href="https://www.ele.me" target="_blank">订单管理</a></el-menu-item> -->
</el-menu>

  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
   // ClerkSubmit
  },
  data() {
    return {
        activeIndex: '1',
    };
    },
    methods: {
        handleSelect(key, keyPath) {
            console.log(key, keyPath);
        }
    }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  width: 80%;
  color: #2c3e50;
  margin-top: 60px;
  margin-left: 100px;
}

.el-menu-item{
    float: none;
    height: 23px;
    line-height: 23px;
    width: auto;
}
</style>
